/*
 * The texts of the notes extension, merged into the lib's own through its js/extension.ts.
 */
export default {
	buttons: {
		note: {
			toggle: 'Collapse or expand overview',
			add: 'Add page',
			rename: 'Edit title',
			delete: 'Delete page',
			up: 'Move up',
			down: 'Move down',
		},
	},
	pages: {
		note_book: {
			table_of_content: 'Overview',
			add_page: 'Add page',
			new_page: 'New page',
			draft_hint: 'created as you type',
			placeholder: 'Write a note',
			untitled: 'Untitled',
		},
	},
	confirms: {
		delete_note_page: {
			title: 'Delete page',
			text: 'Do you really want to delete the page "{title}"?',
		},
	},
};
